<div class="section over-hide padding-top-120 padding-bottom-40 section-background-rana" id="page-section">
    <div class="section-1400">
        <div class="container-fluid">
            <div class="row justify-content-center padding-top-20">
                <div class=" text-center " data-scroll-reveal="enter bottom move 40px over 0.5s after 0.3s">
                    <h4 class="mb-3 font-weight-600">
                        About Rajput Association of North America (RANA) </h4>
                    <p class="lead mb-0">
                        The Rajput Association of North America (RANA) was established in 1980 with the adoption of the
                        Constitution
                        at the 1st General Body Meeting and induction of the elected Executive Committee. It has grown
                        from the six
                        founding families represented by the six heads in the crown of the RANA seal to the
                        approximately 700
                        families in 2016. It was incorporated in 1984 as a non-profit fraternal organization in the
                        State of New
                        Jersey.
                    </p>
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="col-12 padding-top-40 text-center">
                    <h6 class="color-primary text-uppercase mb-2">

                    </h6>
                    <h3 class="display-8 mb-4">
                        <span class="font-weight-600">RANA's </span> <span class="title-line-bottom font-weight-700">Prime </span>
                        <span class="font-weight-600"> Objective.</span>
                    </h3>
                    <p class="lead mb-0">

                    </p>
                </div>
                <div class="col-md-4 col-lg pr-xl-5 " data-scroll-reveal="enter bottom move 40px over 0.5s after 0.3s">
                    <div class="section border-4 services-wrap-3 process light-border p-4 bg-purple">
                        <div class="service-back-text font-weight-400 color-gray font-italic pt-2 pr-3 text-right">
                            01
                        </div>
                        <h5 class="mb-3 padding-top-20">
                            Unite Rajputs

                        </h5>
                        <p class="mb-3 mb-sm-5">
                            To foster and maintain relations among Rajputs in North America.
                        </p>

                    </div>
                </div>
                <div class="col-md-4 col-lg-5 px-xl-4 mt-4 mt-md-0"
                     data-scroll-reveal="enter bottom move 40px over 0.5s after 0.3s">
                    <div class="section border-4 services-wrap-3 process light-border p-4 bg-orange">
                        <div class="service-back-text font-weight-400 color-gray font-italic pt-2 pr-3 text-right">
                            02
                        </div>
                        <h5 class="mb-3 padding-top-20">
                            Cultural Preservation
                        </h5>
                        <p class="mb-3 mb-sm-5">
                            To provide a common platform for the present and future generations of Rajputs in North
                            America and to
                            behold and preserve the Rajput culture, traditions, and values.
                        </p>

                    </div>
                </div>
                <div class="col-md-4 col-lg pl-xl-5 mt-4 mt-md-0"
                     data-scroll-reveal="enter bottom move 40px over 0.5s after 0.3s">
                    <div class="section border-4 services-wrap-3 p-4 bg-red">
                        <div class="service-back-text font-weight-400 color-gray font-italic pt-2 pr-3 text-right">
                            03
                        </div>
                        <h5 class="mb-3 padding-top-20">
                            Community <br> Engagement
                        </h5>
                        <p class="mb-3 mb-sm-5">
                            To develop social, cultural, educational, business, and charity programs and to encourage
                            active
                            participation of all members in these programs.
                        </p>

                    </div>
                </div>
                <div class="col-md-6 mt-4 mt-xl-5 pr-xl-5"
                     data-scroll-reveal="enter bottom move 40px over 0.5s after 0.3s">
                    <div class="section border-4 services-wrap-3 process-2  light-border p-4 bg-blue">
                        <div class="service-back-text font-weight-400 color-gray font-italic pt-2 pr-3 text-right">
                            04
                        </div>
                        <h5 class="mb-3 text-white padding-top-20">
                            Global Connectivity
                        </h5>
                        <p class="mb-3 mb-sm-5  text-white">
                            To establish and develop links with other Rajput organizations throughout the world.
                        </p>

                    </div>
                </div>
                <div class="col-md-6 mt-4 mt-xl-5 pl-xl-5"
                     data-scroll-reveal="enter bottom move 40px over 0.5s after 0.3s">
                    <div class="section border-4 services-wrap-3 p-4 bg-teal">
                        <div class="service-back-text font-weight-400 color-gray font-italic pt-2 pr-3 text-right">
                            05
                        </div>
                        <h5 class="mb-3  text-white padding-top-20">
                            Protection of our Community
                        </h5>
                        <p class="mb-3 mb-sm-5  text-white">
                            Take all necessary actions to safeguard and promote the best interests of its members in
                            achieving the
                            above objectives.
                        </p>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- About us
================================================== -->

<div class="section over-hide bg-light-2 padding-top-20">
    <div class="container-fluid">
        <div class="row px-0">
            <div class="col-lg-6 px-0 img-wrap">
                <img src="img/about-1.jpg" alt="">
            </div>
            <div class="col-lg-6 px-0 py-5 py-lg-0 align-self-center"
                 data-scroll-reveal="enter right move 40px over 0.5s after 0.3s">
                <div class="row justify-content-center">
                    <div class="col-11 col-lg-11 col-xl-7">
                        <h4 class="mb-4">
                            Rana Youth

                        </h4>
                        <p class="lead mb-3 text-center-v">
                            <i class="uil uil-trophy size-22 mr-3 color-primary"></i>
                            Rising Together, Leading Tomorrow!
                        </p>
                        <p class="mb-5">
                            RANA Youth is the youth division of RANA that hosts its own conventions and events. RANA
                            Youth's aim is to
                            inspire social and professional networking among Rajput youth around the world.
                        </p>
                        <div class="section sign-wrap">
                            <img src="img/sign.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="section over-hide padding-bottom-40 bg-light-2">
    <div class="section-1400">

        <p class="lead mb-3 text-center-v">
            <i class="uil uil-cog size-22 mr-3 color-primary"></i>
            Other Services Includes:
        </p>
        <div class="container-fluid">

            <div class="row">


                <div class="col-md-4 pr-xl-5" data-scroll-reveal="enter bottom move 40px over 0.5s after 0.3s">
                    <div class="section border-4 services-wrap-3 process px-4 px-xl-5 py-5 text-center"
                         data-scroll-reveal="enter bottom move 40px over 0.5s after 0.3s">
                        <p class="mb-2"><i class="uil uil-notes size-50"></i></p>
                        <h6 class="mb-4">
                            RANA Education Fund
                        </h6>
                        <p class="mb-0">
                            RANA provides annual scholarships of ₹15,000 to deserving Rajput students in India. In North
                            America, $500
                            scholarships are awarded to qualified children of RANA members.
                        </p>
                    </div>
                </div>
                <div class="col-md-4 px-xl-4 mt-4 mt-md-0"
                     data-scroll-reveal="enter bottom move 40px over 0.5s after 0.3s">
                    <div class="section border-4 services-wrap-3 process px-4 px-xl-5 py-5 text-center"
                         data-scroll-reveal="enter bottom move 40px over 0.5s after 0.3s">
                        <p class="mb-2"><i class="uil uil-book-open size-50"></i></p>
                        <h6 class="mb-4">
                            Publications
                        </h6>
                        <p class="mb-0">
                            RANA publishes the 'Rajputra' magazine, a biennial membership directory, regular
                            e-newsletters, and
                            maintains its online presence through its website, rajputra.org, and Facebook page,
                            facebook.com/RajputAssociationRANA.
                        </p>
                    </div>
                </div>
                <div class="col-md-4 pl-xl-5 mt-4 mt-md-0"
                     data-scroll-reveal="enter bottom move 40px over 0.5s after 0.3s">
                    <div class="section border-4 services-wrap-3 px-4 px-xl-5 py-5 text-center"
                         data-scroll-reveal="enter bottom move 40px over 0.5s after 0.3s">
                        <p class="mb-2"><i class="uil uil-users-alt size-50"></i></p>
                        <h6 class="mb-4">
                            Events
                        </h6>
                        <p class="mb-0">
                            Alongside local chapter events like Holi, camping, picnics, and Diwali, RANA has hosted
                            popular biennial
                            Family and Youth Conventions since 1995, adding successful Business Conventions in 2016,
                            held alternately
                            with Family Conventions starting in 2017.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="section over-hide">
    <div class="section-1400">
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-6 col-md-4 col-lg-3 text-center">
                    <div class="section divider"></div>
                </div>
            </div>
        </div>
        <div class="container-fluid padding-top-bottom-80"
             data-scroll-reveal="enter bottom move 40px over 0.5s after 0.3s">
            <div class="row justify-content-center">
                <div class="col-md-6 col-lg-3 text-center border-counters-right">
                    <div class="counter-big-num mb-0 font-weight-400"><span class="counter ">1500</span>+</div>
                    <p class="lead mb-0 py-4 font-weight-600 position-relative z-bigger color-dark-blue">
                        Rajput Families
                    </p>
                </div>
                <div class="col-md-6 col-lg-3 mt-5 mt-md-0 text-center border-counters-right">
                    <div class="counter-big-num mb-0 font-weight-400"><span class="counter">500</span></div>
                    <p class="lead mb-0 py-4 font-weight-600 position-relative z-bigger color-dark-blue">
                        Rajput Youths
                    </p>
                </div>
                <div class="col-md-6 col-lg-3 mt-5 mt-lg-0 text-center border-counters-right">
                    <div class="counter-big-num mb-0 font-weight-400"><span class="counter">5K</span>+</div>
                    <p class="lead mb-0 py-4 font-weight-600 position-relative z-bigger color-dark-blue">
                        Events
                    </p>
                </div>
                <div class="col-md-6 col-lg-3 mt-5 mt-lg-0 text-center">
                    <div class="counter-big-num mb-0 font-weight-400"><span class="counter">15</span></div>
                    <p class="lead mb-0 py-4 font-weight-600 position-relative z-bigger color-dark-blue">
                        Chapters
                    </p>
                </div>
            </div>
        </div>
        <div class="container-fluid">
            <div class="row justify-content-center">
                <div class="col-6 col-md-4 col-lg-3 text-center">
                    <div class="section divider"></div>
                </div>
            </div>
        </div>
    </div>
</div>